import cardSlides from './cardSlides';

const smSlides = cardSlides;

export default smSlides;
